import * as React from 'react';

import * as collaborationProvider from 'src/utils/collaboration/collaborationProvider';

/**
 * Subscribe to the collaboration connection status for a given project.
 *
 * @param projectId - The project to watch
 * @returns The current status string, or undefined if no connection exists
 */
export const useCollaborationStatus = (
  projectId: string
): string | undefined => {
  const [status, setStatus] = React.useState(() =>
    collaborationProvider.getStatus(projectId)
  );

  React.useEffect(() => {
    // Sync in case the status changed between render and effect
    setStatus(collaborationProvider.getStatus(projectId));

    const unsubscribe = collaborationProvider.addStatusChangeEventListener(
      (changedProjectId, newStatus) => {
        if (changedProjectId === projectId) {
          setStatus(newStatus);
        }
      }
    );

    return unsubscribe;
  }, [projectId]);

  return status;
};
